import {
  IconBottleFilled,
  IconBowlSpoonFilled,
  IconBreadFilled,
  IconCookieFilled,
  IconEggFriedFilled,
  IconGlassFilled,
  IconGlassFullFilled,
  IconLeafFilled,
  IconMilkFilled,
  IconMugFilled,
  IconPizzaFilled,
  IconSaladFilled,
} from '@tabler/icons-react';

const categoryIcons = {
  coffee: IconMugFilled,
  tea: IconLeafFilled,
  drink: IconGlassFilled,
  snack: IconCookieFilled,
  cake: IconBreadFilled,
  bread: IconBreadFilled,
  food: IconBowlSpoonFilled,
  breakfast: IconEggFriedFilled,
  Coffee: IconMugFilled,
  Cup: IconGlassFullFilled,
  Cake: IconBreadFilled,
  Meat: IconBowlSpoonFilled,
  Cookie: IconCookieFilled,
  'Ice cream': IconMilkFilled,
  Salad: IconSaladFilled,
  Pizza: IconPizzaFilled,
  Bottle: IconBottleFilled,
};

export default categoryIcons;
